import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  LayoutDashboard,
  Package,
  Sparkles,
  Award,
  Image,
  Settings,
  LogOut,
  Mail,
  AlignJustify,
  Menu as MenuIcon,
  Search,
  HelpCircle,
  Ticket,
  Gem,
  FileText,
} from 'lucide-react';

export const AdminLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [settings, setSettings] = React.useState(null);

  React.useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`);
        const data = await response.json();
        setSettings(data);
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
    fetchSettings();
  }, []);

  const menuItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/admin/topnav', label: 'Top Nav', icon: MenuIcon },
    { path: '/admin/hero', label: 'Hero Section', icon: Sparkles },
    { path: '/admin/products', label: 'Products', icon: Package },
    { path: '/admin/features', label: 'Features', icon: Award },
    { path: '/admin/gallery', label: 'Gallery', icon: Image },
    { path: '/admin/footer', label: 'Footer', icon: AlignJustify },
    { path: '/admin/contact', label: 'Contact Forms', icon: Mail },
    { path: '/admin/support', label: 'Support', icon: HelpCircle },
    { path: '/admin/seo', label: 'SEO', icon: Search },
    { path: '/admin/relics-content', label: 'Relics Content', icon: Gem },
    { path: '/admin/relic-codes', label: 'Relic Codes', icon: Ticket },
    { path: '/admin/product-description', label: 'Product Description', icon: FileText },
    { path: '/admin/settings', label: 'Settings', icon: Settings },
  ];

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-gray-900 flex">
      {/* Sidebar */}
      <div className="w-64 bg-gray-800 border-r border-gray-700 flex flex-col">
        <div className="p-6 border-b border-gray-700">
          <img
            src={settings?.logo_url || "https://customer-assets.emergentagent.com/job_mtg-sleeves/artifacts/36nq3r5g_Artboard3%402x.png"}
            alt="Planeskeeper"
            className="h-10 mb-3"
          />
          <h1 className="text-white text-xl font-bold">CMS Admin</h1>
          <p className="text-gray-400 text-sm mt-1">{user?.email}</p>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center px-4 py-3 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-orange-600 text-white'
                    : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                }`}
              >
                <Icon className="w-5 h-5 mr-3" />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-gray-700">
          <button
            onClick={handleLogout}
            className="flex items-center px-4 py-3 rounded-lg text-gray-300 hover:bg-gray-700 hover:text-white w-full transition-colors"
          >
            <LogOut className="w-5 h-5 mr-3" />
            <span>Logout</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        <div className="bg-gray-800 border-b border-gray-700 px-8 py-4">
          <h2 className="text-white text-2xl font-bold">
            {menuItems.find((item) => item.path === location.pathname)?.label || 'Admin'}
          </h2>
        </div>
        <div className="flex-1 p-8 overflow-auto">{children}</div>
      </div>
    </div>
  );
};
